export default __webpack_public_path__ + "static/media/withdrawal-bcube.2731bd8d.svg";